import { render, staticRenderFns } from "./overlay-reels.vue?vue&type=template&id=7d8d2410&scoped=true&"
import script from "./overlay-reels.vue?vue&type=script&lang=js&"
export * from "./overlay-reels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d2410",
  null
  
)

export default component.exports